import { Container, Text } from "@mantine/core";
import React from "react";

const Video = () => {
  return (
    <Container>
      <Text className="text-center text-xl text-[#737373] border-b-yellow-500 border-b-2 w-[200px] mx-auto">
        VISIT TO LOURVE
      </Text>
      <iframe
        // width="560"
        // height="315"
        src="https://www.youtube.com/embed/6JCLY0Rlx6Q"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
        className="mx-auto mt-5 w-[300px] h-[180px] md:w-[560px] md:h-[315px]"
      ></iframe>
    </Container>
  );
};

export default Video;
